import { createI18n as createSharedI18n } from '@drama/i18n'
import { createI18n } from 'vue-i18n'
import { en } from './en.js'
import { zh } from './zh.js'
import { ja } from './ja.js'
import { es } from './es.js'
import { id } from './id.js'
import { pt } from './pt.js'

export const adminMessages = { en, zh, ja, es, id, pt }

/**
 * @param {{ locale: string }} opts
 */
export function createAdminI18n(opts) {
  const locale = Object.hasOwn(adminMessages, opts.locale) ? opts.locale : 'zh'
  const i18n = createI18n({
    legacy: false,
    locale,
    fallbackLocale: 'en',
    messages: adminMessages,
  })
  const shared = createSharedI18n({ locale: 'en' })
  const ready = Promise.all(['en', 'zh', 'ja', 'ko', 'es', 'pt'].map(code => shared.loadLocale(code))).then(() => {
    for (const code of Object.keys(adminMessages)) {
      const messages = shared.i18n.global.getLocaleMessage(code === 'id' ? 'en' : code)
      i18n.global.mergeLocaleMessage(code, { visualGame: messages.visualGame })
    }
  })
  return {
    ready,
    i18n,
    getLocale: () => i18n.global.locale.value,
    setLocale(nextLocale) {
      if (!Object.hasOwn(adminMessages, nextLocale)) {
        throw new Error(`Unsupported locale: ${nextLocale}`)
      }
      i18n.global.locale.value = nextLocale
    },
  }
}
